import React from "react";
import { FaCalendarCheck, FaCalendarPlus } from "react-icons/fa";

function ReportViewTabs({ activeTab, onChange, todayCount = 0, tomorrowCount = 0 }) {
  const tabs = [
    {
      id: "today",
      label: "Today's tasks",
      subtitle: "Reported work for this date",
      icon: FaCalendarCheck,
      count: todayCount,
    },
    {
      id: "tomorrow",
      label: "Plan for tomorrow",
      subtitle: "Tasks planned for the next day",
      icon: FaCalendarPlus,
      count: tomorrowCount,
    },
  ];

  return (
    <nav
      className="daily-report-view-tabs grid grid-cols-2 gap-2 rounded-xl border border-slate-200 bg-slate-100 p-1.5"
      role="tablist"
      aria-label="Report sections"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`daily-report-view-tabs__item flex items-center gap-3 rounded-lg px-3 py-2.5 text-left transition ${
              isActive
                ? "bg-white text-slate-900 shadow-sm ring-1 ring-slate-200"
                : "text-slate-600 hover:bg-white/60"
            }`}
            onClick={() => onChange(tab.id)}
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                isActive ? "bg-indigo-50 text-indigo-600" : "bg-slate-200/80 text-slate-500"
              }`}
            >
              <Icon size={14} aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 text-sm font-semibold">
                {tab.label}
                <span
                  className={`inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-bold ${
                    isActive
                      ? "bg-indigo-100 text-indigo-700"
                      : "bg-slate-200 text-slate-600"
                  }`}
                >
                  {tab.count}
                </span>
              </span>
              <span className="mt-0.5 block text-[10px] text-slate-500">{tab.subtitle}</span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}

export default ReportViewTabs;
